/* =========================================================================
   convert-test:sticky-atc — lógica de la VARIANTE B (sólo mobile)

   Este archivo NO decide si el usuario ve el sticky: eso lo hace el CSS de
   activación de Convert sobre `.cro-sticky-atc` (ver snippets/sticky-atc.liquid).
   Aquí sólo vive el comportamiento que corre DENTRO de la variante B:

     1. Mostrar la barra cuando el Add to Cart original sale del viewport por  
        arriba, y esconderla al volver a subir.
     2. Mantener el dropdown del sticky sincronizado con el buy box en ambos
        sentidos.
     3. Bloquear medidas agotadas / combinaciones no disponibles.
     4. Delegar el add to cart en el botón nativo, sin tocar el flujo posterior.

   En la variante A todo esto queda inerte: el contenedor está en display:none,
   así que la barra nunca se ve y su botón nunca puede recibir un click.
   ========================================================================= */
(function () {
  'use strict';

  var LATCH_CLASS = 'cro-sticky-atc-b';
  var VISIBLE_CLASS = 'is-visible';
  var LATCH_INTERVAL = 250;
  var LATCH_MAX_TRIES = 120; /* ~30s */

  /* Evento que marca el instante en que la barra entra por primera vez. Lo
     escucha el location trigger de Convert en sections/page-product.liquid: es
     la única fuente de verdad de "el sticky se está mostrando", para que la
     condición no viva duplicada en dos archivos y se puedan desincronizar. */
  var REVEAL_EVENT = 'cro:sticky-atc:reveal';
  var revealed = false;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  /* Evalúa `fn` en cada scroll/resize, como mucho una vez por frame.

     NO se usa IntersectionObserver a propósito: sólo emite callback cuando el
     estado de intersección CAMBIA, y un scroll que salta el ATC de un tirón
     (fling en touch, un ancla, restaurar la posición al volver atrás) lo lleva
     de "no intersecta porque está abajo" a "no intersecta porque está arriba"
     sin cruzar el threshold. En ese caso el observer nunca avisa y la barra se
     quedaba oculta para siempre. Reproducido en pruebas. */
  function enCadaScroll(fn) {
    var pendiente = false;
    var vivo = true;

    function tick() {
      pendiente = false;
      if (vivo) { fn(); }
    }

    function programar() {
      if (pendiente || !vivo) { return; }
      pendiente = true;
      window.requestAnimationFrame(tick);
    }

    window.addEventListener('scroll', programar, { passive: true });
    window.addEventListener('resize', programar, { passive: true });

    programar();

    return function detener() {
      vivo = false;
      window.removeEventListener('scroll', programar);
      window.removeEventListener('resize', programar);
    };
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function init() {
    var root = document.querySelector('[data-cro-sticky-atc]');
    if (!root || root.getAttribute('data-cro-ready') === 'true') { return; }

    var form = document.getElementById(root.getAttribute('data-form'));
    if (!form) { return; }

    /* Ancla del scroll: el contenedor del botón original. Existe tanto cuando el
       producto está disponible como cuando está agotado, así que la barra
       aparece en el mismo punto en los dos casos. */
    var anchor = form.querySelector('.payment-buttons-container') || form.querySelector('.add-to-cart');
    var submit = root.querySelector('[data-cro-sticky-submit]');
    if (!anchor || !submit) { return; }

    root.setAttribute('data-cro-ready', 'true');

    var nativeSubmit = form.querySelector('input.add-to-cart[type="submit"]');
    var variantField = form.querySelector('[data-variants]');
    var selects = toArray(root.querySelectorAll('[data-cro-option]'));
    var variants = readVariants(root);

    /* ---------------------------------------------------------------------
       Estado del buy box
       --------------------------------------------------------------------- */

    /* Controles nativos de una opción. Con settings.product_option_style ==
       'buttons' son radios; el theme también soporta un <select>, así que se
       cubren los dos casos. */
    function mainControls(optionKey) {
      return toArray(form.querySelectorAll('[data-product-option="' + optionKey + '"]'));
    }

    function mainSelection(optionKey) {
      var controls = mainControls(optionKey);
      if (!controls.length) { return null; }

      var disabled = {};

      if (controls[0].tagName === 'SELECT') {
        toArray(controls[0].options).forEach(function (option) {
          disabled[option.value] = !!option.disabled;
        });
        return { value: controls[0].value, disabled: disabled };
      }

      var value = null;
      controls.forEach(function (input) {
        disabled[input.value] = !!input.disabled;
        if (input.checked) { value = input.value; }
      });

      return { value: value, disabled: disabled };
    }

    /* Valores seleccionados hoy, leídos del buy box (fuente de verdad) y con el
       sticky como respaldo si el buy box todavía no responde. */
    function currentValues() {
      return selects.map(function (select) {
        var state = mainSelection(select.getAttribute('data-cro-option'));
        return state && state.value !== null ? state.value : select.value;
      });
    }

    /* ¿Hay alguna variante disponible con `value` en la posición `index`,
       respetando el resto de opciones ya elegidas? Es el mismo criterio que usa
       pacific.js para deshabilitar los botones del buy box, así que el sticky y
       el buy box nunca se contradicen. */
    function valueIsAvailable(index, value, values) {
      for (var v = 0; v < variants.length; v++) {
        var variant = variants[v];
        if (!variant.available) { continue; }

        var match = true;
        for (var i = 0; i < values.length; i++) {
          var expected = i === index ? value : values[i];
          if (variant.options[i] !== expected) { match = false; break; }
        }

        if (match) { return true; }
      }

      return false;
    }

    function selectedVariant() {
      var values = currentValues();

      for (var v = 0; v < variants.length; v++) {
        var variant = variants[v];
        var match = true;

        for (var i = 0; i < values.length; i++) {
          if (variant.options[i] !== values[i]) { match = false; break; }
        }

        if (match) { return variant; }
      }

      return null;
    }

    /* ---------------------------------------------------------------------
       Buy box  ->  sticky
       --------------------------------------------------------------------- */
    function syncFromMain() {
      var values = currentValues();

      selects.forEach(function (select, index) {
        var state = mainSelection(select.getAttribute('data-cro-option'));

        /* Una medida se bloquea si el buy box ya la marcó agotada O si el mapa
           de variantes dice que no hay stock para esa combinación. La unión de
           ambos criterios evita que una talla agotada quede seleccionable si
           pacific.js todavía no alcanzó a correr. */
        toArray(select.options).forEach(function (option) {
          var blockedByBuyBox = !!(state && state.disabled[option.value]);
          option.disabled = blockedByBuyBox || !valueIsAvailable(index, option.value, values);
        });

        if (state && state.value !== null && select.value !== state.value) {
          select.value = state.value;
        }
      });

      updateSubmit();
    }

    function updateSubmit() {
      var variant = selectedVariant();
      var available = !!(variant && variant.available);

      submit.disabled = !available;
      submit.textContent = available
        ? submit.getAttribute('data-label-add')
        : submit.getAttribute('data-label-soldout');
    }

    /* ---------------------------------------------------------------------
       Sticky  ->  buy box
       --------------------------------------------------------------------- */
    function fireChange(el) {
      /* pacific.js escucha con jQuery .on('change'), que por debajo es un
         addEventListener: un evento nativo despachado aquí lo activa igual, y de
         paso corre el resto de listeners nativos del theme (el que actualiza el
         valor de la opción junto al label, por ejemplo). */
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function syncToMain(select) {
      var controls = mainControls(select.getAttribute('data-cro-option'));
      var value = select.value;
      if (!controls.length) { return; }

      if (controls[0].tagName === 'SELECT') {
        if (controls[0].value === value) { return; }
        controls[0].value = value;
        fireChange(controls[0]);
        return;
      }

      var target = null;
      controls.forEach(function (input) {
        if (input.value === value) { target = input; }
      });

      if (!target || target.checked) { return; }

      /* Los radios comparten `name`, así que marcar el elegido desmarca al
         resto y el label del buy box se actualiza solo vía :checked. */
      target.checked = true;
      fireChange(target);
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        syncToMain(select);
        /* pacific.js recalcula la variante de forma síncrona dentro del change,
           pero se deja un tick por si otro script del theme reacciona después. */
        window.setTimeout(syncFromMain, 0);
      });
    });

    /* El theme avisa cada cambio de variante con un evento jQuery en window; es
       la señal más fiable para reflejar en el sticky lo que se eligió arriba. */
    if (window.jQuery) {
      window.jQuery(window).on('shopify-variants:switch-variant.croStickyAtc', function () {
        syncFromMain();
      });
    }

    /* Respaldo para cualquier cambio hecho directo sobre el buy box (incluido el
       primer render, cuando pacific.js deshabilita las tallas agotadas). */
    form.addEventListener('change', function (event) {
      if (event.target && event.target.hasAttribute && event.target.hasAttribute('data-product-option')) {
        window.setTimeout(syncFromMain, 0);
      }
    });

    /* ---------------------------------------------------------------------
       Add to cart
       --------------------------------------------------------------------- */
    submit.addEventListener('click', function (event) {
      event.preventDefault();

      syncFromMain();

      var variant = selectedVariant();

      /* Nunca se agrega una variante agotada o inexistente. */
      if (!variant || !variant.available) { return; }

      /* El campo que serializa el theme al mandar el form. pacific.js ya lo pone
         al día en cada cambio de variante; esto sólo cubre el caso de que el
         helper no haya llegado a inicializarse. */
      if (variantField && variantField.value !== String(variant.id)) {
        variantField.value = String(variant.id);
      }

      /* Se delega en el botón original para conservar TAL CUAL el flujo actual:
         pacific.js intercepta el submit, hace POST a /cart/add.js y manda al
         carrito. Esta prueba no toca nada de lo que pasa después del add. */
      if (nativeSubmit && !nativeSubmit.disabled) {
        nativeSubmit.click();
        return;
      }

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
        return;
      }

      form.submit();
    });

    /* ---------------------------------------------------------------------
       Visibilidad por scroll
       --------------------------------------------------------------------- */
    function setVisible(on) {
      if (!on) {
        root.classList.remove(VISIBLE_CLASS);
        return;
      }

      root.classList.add(VISIBLE_CLASS);

      /* Primera vez que la barra entra: se avisa para que el location trigger de
         Convert dispare EXACTAMENTE aquí y no antes.

         Este instante sirve como señal en las DOS variantes: la clase
         `is-visible` se aplica igual en A y en B, porque depende sólo del
         scroll — lo único que cambia entre variantes es el `display` del
         contenedor. Así que el momento es un hecho de scroll, no de variante, y
         disparar aquí no sesga la muestra.

         La bandera en window cubre el caso de que el trigger se suscriba tarde
         (por ejemplo si la página ya venía scrolleada por debajo del ATC). */
      if (revealed) { return; }

      revealed = true;
      window.__croStickyAtcRevealed = true;

      try {
        window.dispatchEvent(new CustomEvent(REVEAL_EVENT));
      } catch (error) {
        /* CustomEvent no construible (navegadores muy viejos): la bandera de
           arriba sigue sirviendo, el trigger la ve en su siguiente sondeo. */
      }
    }

    function watchAnchor() {
      enCadaScroll(function () {
        /* Sólo cuando el ATC original quedó ARRIBA del viewport. Si todavía
           está más abajo (usuario arriba de la PDP) el sticky no aparece. */
        setVisible(anchor.getBoundingClientRect().bottom < 0);
      });
    }

    /* ---------------------------------------------------------------------
       Latch de la variante B (ver el comentario largo del snippet)
       --------------------------------------------------------------------- */
    function latch() {
      var html = document.documentElement;
      if (html.classList.contains(LATCH_CLASS)) { return true; }
      if (window.getComputedStyle(root).display === 'none') { return false; }

      html.classList.add(LATCH_CLASS);
      return true;
    }

    function waitForActivation() {
      if (latch()) { return; }

      var tries = 0;
      var timer = window.setInterval(function () {
        tries += 1;
        if (latch() || tries > LATCH_MAX_TRIES) { window.clearInterval(timer); }
      }, LATCH_INTERVAL);
    }

    syncFromMain();
    watchAnchor();
    waitForActivation();

    /* pacific.js deshabilita las tallas agotadas en su primer _switchVariant, y
       ese primer disparo puede ocurrir antes de que este archivo (defer) alcance
       a suscribirse al evento. Un par de re-sincronizaciones tempranas dejan el
       sticky alineado con el buy box sin importar el orden de carga. */
    [0, 300, 1000].forEach(function (delay) {
      window.setTimeout(syncFromMain, delay);
    });
  }

  function readVariants(root) {
    var tag = root.querySelector('[data-cro-sticky-variants]');
    if (!tag) { return []; }

    try {
      return JSON.parse(tag.textContent) || [];
    } catch (error) {
      return [];
    }
  }

  ready(init);
  /* pacific.js puede reinicializar la sección en el theme editor; el guard
     data-cro-ready hace que este segundo intento sea inocuo. */
  window.addEventListener('load', init);
})();
